import React from 'react';
import { useLocation } from 'react-router-dom';
import EthicsPage from '../../pages/EthicsPage';
import useIsMobile from '../../shared/hooks/useIsMobile';
import ContactMobile from './Contact.mobile';
import ContactDesktop from './Contact.desktop';

const ContactFeature = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  const View = isMobile ? ContactMobile : ContactDesktop;
  const channel = new URLSearchParams(location.search).get('canal');
  if (['etica', 'ethics'].includes(channel) || location.hash === '#canal-de-etica') return <EthicsPage />;
  return <View />;
};

export default ContactFeature;
